import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const getToken = () => localStorage.getItem("token");

export const FETCH_BLOGS_REQUEST = "FETCH_BLOGS_REQUEST";
export const FETCH_BLOGS_SUCCESS = "FETCH_BLOGS_SUCCESS";
export const FETCH_BLOGS_FAILURE = "FETCH_BLOGS_FAILURE";

export const CREATE_BLOG_REQUEST = "CREATE_BLOG_REQUEST";
export const CREATE_BLOG_SUCCESS = "CREATE_BLOG_SUCCESS";
export const CREATE_BLOG_FAILURE = "CREATE_BLOG_FAILURE";

export const UPDATE_BLOG_REQUEST = "UPDATE_BLOG_REQUEST";
export const UPDATE_BLOG_SUCCESS = "UPDATE_BLOG_SUCCESS";
export const UPDATE_BLOG_FAILURE = "UPDATE_BLOG_FAILURE";

export const DELETE_BLOG_REQUEST = "DELETE_BLOG_REQUEST";
export const DELETE_BLOG_SUCCESS = "DELETE_BLOG_SUCCESS";
export const DELETE_BLOG_FAILURE = "DELETE_BLOG_FAILURE";


/* ================= FETCH BLOGS ================= */

export const fetchBlogs = () => async (dispatch) => {
  dispatch({ type: FETCH_BLOGS_REQUEST });

  try {
    const response = await axios.get(
      `${BASE_URL}/v1/api/admin/blog/list`,
      {
        headers: { Authorization: getToken() },
      }
    );

    dispatch({
      type: FETCH_BLOGS_SUCCESS,
      payload: response.data?.data || [],
    });

  } catch (error) {
    const errorMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch blogs";

    dispatch({ type: FETCH_BLOGS_FAILURE, payload: String(errorMsg) });

    toast.error(String(errorMsg));
  }
};


/* ================= CREATE BLOG ================= */

export const createBlog = (blogData) => async (dispatch) => {
  dispatch({ type: CREATE_BLOG_REQUEST });

  try {
    const response = await axios.post(
      `${BASE_URL}/v1/api/admin/blog/create`,
      blogData,
      {
        headers: { Authorization: getToken() },
      }
    );

    dispatch({
      type: CREATE_BLOG_SUCCESS,
      payload: response.data?.data,
    });

    toast.success("Blog created successfully");

    return true;

  } catch (error) {
    const errorMsg =
      error.response?.data?.message ||
      error.message ||
      "Create failed";

    dispatch({ type: CREATE_BLOG_FAILURE, payload: errorMsg });

    toast.error(errorMsg);

    return false;
  }
};


/* ================= UPDATE BLOG ================= */

export const updateBlog = (id, blogData) => async (dispatch) => {
  dispatch({ type: UPDATE_BLOG_REQUEST });

  try {
    const response = await axios.put(
      `${BASE_URL}/v1/api/admin/blog/update/${id}`,
      blogData,
      {
        headers: { Authorization: getToken() },
      }
    );

    dispatch({
      type: UPDATE_BLOG_SUCCESS,
      payload: response.data?.data,
    });

    toast.success("Blog updated successfully");

  } catch (error) {
    const errorMsg =
      error.response?.data?.message ||
      error.message ||
      "Update failed";

    dispatch({ type: UPDATE_BLOG_FAILURE, payload: String(errorMsg) });

    toast.error(String(errorMsg));
  }
};


/* ================= DELETE BLOG ================= */

export const deleteBlog = (id) => async (dispatch) => {
  dispatch({ type: DELETE_BLOG_REQUEST });

  try {
    await axios.delete(
      `${BASE_URL}/v1/api/admin/blog/delete/${id}`,
      {
        headers: { Authorization: getToken() },
      }
    );

    dispatch({
      type: DELETE_BLOG_SUCCESS,
      payload: id,
    });

    toast.success("Blog deleted successfully");

  } catch (error) {
    const errorMsg =
      error.response?.data?.message ||
      error.message ||
      "Delete failed";

    dispatch({ type: DELETE_BLOG_FAILURE, payload: String(errorMsg) });

    toast.error(String(errorMsg));
  }
};